/**
 * @file
 * Contains local storage service.
 */

import { safeSetLocalStorage } from '@wwe-portal/web/libs/storage/safe-local-storage';

/**
 * Set data to local storage.
 * @param {string} key.
 * @param {object} value.
 */
const setStorageItem = (key: string, value: string | null | undefined) => {
  // Guard so a full quota logs instead of crashing the page. No recovery: these
  // are non-critical writes and have nothing of their own worth pruning.
  safeSetLocalStorage(key, () => JSON.stringify(value));
};

const getStorageItem = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    return JSON.parse(item);
  } catch {
    return null;
  }
};

/**
 * Remove data from local storage.
 * @param {string} key.
 */
const removeStorageItem = (key: string) => {
  localStorage.removeItem(key);
};

export { setStorageItem, getStorageItem, removeStorageItem };
